import { FocusMonitor } from '@angular/cdk/a11y';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  Optional,
  Self,
  ViewChild,
} from '@angular/core';
import { FormBuilder, NgControl } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { MatLegacyFormFieldControl as MatFormFieldControl } from '@angular/material/legacy-form-field';
import { MatLegacySelect as MatSelect } from '@angular/material/legacy-select';

import { DefaultMatcher } from '@shared/helpers/default-error-state-matcher';

import { BaseMatControlComponent } from '../../base-mat-control.component';

@Component({
  selector: 'app-easy-select',
  templateUrl: './easy-select.component.html',
  styleUrls: ['./easy-select.component.scss'],
  providers: [
    { provide: MatFormFieldControl, useExisting: EasySelectComponent },
  ],
})
export class EasySelectComponent
  extends BaseMatControlComponent<Array<any> | any>
  implements AfterViewInit
{
  @Input() options: Array<any> = [];
  @Input() hasEmptyOption: boolean = true;
  @Input() multiple = false;
  @Input() limit: number = 0;
  @Input() labelAttribute = '';
  @Input() valueAttribute = '';
  @Input() translatePrefixForSelected = '';
  @Input() groupLabelAttribute = '';
  @Input() groupOptionsAttribute = '';
  @Input() showSelectedLabels = false;
  @Input() showStatusLabel = false;
  @Input() labelInfo?: string = undefined;
  @Input() differentLabelWhenSelected = false;
  @Input() errorStateMatcher: ErrorStateMatcher = new DefaultMatcher();

  @ViewChild('easySelect') easySelect!: MatSelect;

  // TODO limit with Validators.maxlength
  get limitReached(): boolean {
    return this.limit > 0 && this.value?.length >= this.limit;
  }

  constructor(
    @Optional() @Self() public override ngControl: NgControl,
    protected override formBuilder: FormBuilder,
    protected override focusMonitor: FocusMonitor,
    protected override elRef: ElementRef,
    private cdr: ChangeDetectorRef
  ) {
    super(ngControl, formBuilder, focusMonitor, elRef);

    this.controlIdentity = 'easy-select';
    this.controlType = 'mat-select';
  }

  ngAfterViewInit() {
    this.userAriaDescribedBy = `${this.id}-required-error ${this.id}-required-payment-method-error`;
  }

  onSelectField(event: KeyboardEvent) {
    if (event.code === 'Escape') {
      event.preventDefault();
      event.stopPropagation();
      this.easySelect.close();
    }
  }

  removeSelected(itemToRemove: any) {
    this.value = this.value.filter(
      (item: any) => JSON.stringify(item) !== JSON.stringify(itemToRemove)
    );
    this.cdr.detectChanges();
  }

  onScroll(event: WheelEvent) {
    if (this.ngControl.disabled) {
      event.stopPropagation();
    }
  }
}
